export const JOINT = 'joint';
export const INDIVIDUAL = 'individual';
export const IS_CAP_ONE_DISABLE_PARAM = 'capOneAppDisable';
export const FINANCING_FF_APP_DISABLED = 'financing-ff-app-disabled';
export const PRE_QUALIFICATION_APPLICATION = 'Pre-qualification Application';
export const PRE_QUALIFICATION_RESULT = 'Pre-qualification Results';
export const CAPITAL_ONE_LOGO_SRC = '/img/car-buying/capital1/capital_one.png';
export const CAPITAL_ONE_LOGO_SRC_NON_PARTNER = '/img/car-buying/capital1/cap-one3.png';
export const CAPITAL_ONE_ENTRY_POINT_CONTENT = {
  TITLE: 'See If You Prequalify',
  SUBTITLE: 'Get prequalified in minutes with no impact to your credit score from Capital One.',
  CTA_TEXT: 'Get prequalified',
};

export const PRE_QUALIFICATION_CALCULATOR = 'Prequalify to see your real payments on Edmunds';
const NO_IMPACT = {
  text1: 'No impact',
  text2: 'on credit score',
  icon: '/img/car-buying/capital1/credit_card_green.svg',
  width: 33,
};
const DECISION = {
  text1: 'Decision in',
  text2: 'minutes',
  icon: '/img/car-buying/capital1/fast_stopwatch_green.svg',
  width: 35,
};
const DECISION_IN_MINUTES = {
  text1: 'Decision in minutes',
  text2: '',
  icon: '/img/car-buying/capital1/fast_stopwatch_green.svg',
  width: 35,
};
const RATE_PAYMENT = {
  text1: 'Real rates and',
  textIneligible1: 'Real payments',
  text2: 'payments',
  textIneligible2: 'on eligible cars',
  icon: '/img/car-buying/capital1/hand_with_coin_green.svg',
  width: 30,
};
const RATE_PAYMENT_ELIGIBLE_CAR = {
  text1: 'Real payments',
  text2: 'on eligible cars',
  icon: '/img/car-buying/capital1/hand_with_coin_green.svg',
  width: 30,
};
export const ENTRYPOINT_ICONS_WITH_TEXT = [NO_IMPACT, DECISION, RATE_PAYMENT];
export const ENTRYPOINT_ICONS_WITH_TEXT_INTEREST_CALCULATOR = [NO_IMPACT, DECISION_IN_MINUTES, RATE_PAYMENT];
export const ENTRYPOINT_ICONS_WITH_TEXT_CALCULATOR = [NO_IMPACT, DECISION, RATE_PAYMENT_ELIGIBLE_CAR];
export const OTHER = 'other';
export const USED_SUMMARY_CHECKOUT = 'used-summary_checkout';

export const CAPITAL_ONE_ENTRY_POINT_PHOTOFLIPPER = {
  CTA_TEXT: 'Get Prequalified',
  CTA_TEXT_MOBILE: 'See if you prequalify',
  DRIVEWAY_CTA_TEXT: 'Get It Delivered',
  BENEFITS: ['No impact\n on credit score', 'Decision in\n minutes', 'Real rates and\n payments'],
  TEXT: 'Prequalify with no impact on your credit score',
  DRIVEWAY_TEXT: '7 day return period and online checkout',
  HEADER_MOBILE: 'See Your Payments on Edmunds',
};

export const TRACKING_BOL_BTN_CLICK = 'bol_btn_click';
export const TRACKING_FINANCING_CTA = 'financing_cta';
export const TRACKING_FINANCING_LEAD_CTA = 'financing_cta_lead_form';

export const CARZING_PREQUALIFY_ENTRY_POINT = {
  header: 'See If You Pre-qualify',
  benefits: [
    {
      icon: '/img/car-buying/capital1/credit_card_green.svg',
      width: 33,
      text: 'No impact \non credit score',
    },
    { icon: '/img/car-buying/capital1/fast_stopwatch_green.svg', width: 35, text: 'Decision in \nminutes' },
    {
      icon: '/img/car-buying/capital1/hand_with_coin_green.svg',
      width: 33,
      text: 'Real rates \nand payments',
    },
  ],
  ctaText: 'Get Prequalified',
};

export const FINANCING_CARZING_PREQUAL_CREATIVE_ID = 'used-summary_financing-carzing_prequal';
export const FINANCING_CARZING_PREQUAL_TRIAL_CREATIVE_ID = 'used-summary_financing-carzing-trial_prequal';

export const USED_PREQUALIFICATION_FINANCING_LEAD = 'used-prequalification-financing_lead';
